<template>
    <div
        class="card mb-0 shadow"
        v-if="$store.state.user.permissions.DemandaController"
    >
        <div class="card-body p-2">
            <div class="row" style="height: calc(100vh - 130px)">
                <div
                    class="col-4"
                    v-show="size > 0"
                    style="height: 85vh; overflow-y: auto"
                >
                    <SupportDemandList @selected="setSupport" @size="setSize" />
                </div>
                <div :class="`${size > 0 ? 'col-8' : 'col-12'}`">
                    <ChatDemandBox
                        mode="page"
                        :selected="selected"
                        @novo="selected = null"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatDemandBox from "@/dashboard/components/widgets/demanda/ChatBoxDemanda";
import SupportDemandList from "./includes/SupportDemandList.vue";

export default {
    components: {
        ChatDemandBox,
        SupportDemandList,
    },
    data() {
        return { selected: null, size: 0 };
    },
    methods: {
        setSupport(id) {
            this.selected = id;
        },
        setSize(size) {
            this.size = size;
        },
    },
};
</script>
